import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Helper } from '../services/helper';

export const authGuard: CanActivateFn = () => {
  const helper = inject(Helper);
  const router = inject(Router);
  const userData = helper.getUserData();
  const userToken = helper.getUserToken();

  if (!userData || !userToken || helper.isJwtTokenExpired(userToken)) {
    helper.clearSession();
    router.navigate(['/login']);
    return false;
  }

  return true;
};
